import { TabsProps } from './type';
import OptionalViewport from '../../../../OptionalViewport';
import DesktopTabs from './DesktopTabs';
import MobileTabs from './MobileTabs';

type Props = TabsProps & {
  isMobile?: boolean;
};

const Tabs = ({ isMobile, ...props }: Props) => {
  return (
    <>
      <OptionalViewport viewport={'mobile'} initIsMobile={isMobile}>
        <MobileTabs {...props} />
      </OptionalViewport>
      <OptionalViewport viewport={'desktop'} initIsMobile={isMobile}>
        <DesktopTabs {...props} />
      </OptionalViewport>
    </>
  );
};

export default Tabs;
